<template>
  <div class="dashboard-block">
    <h2>Card Details</h2>

    <ul class="item-detail item-detail-simple" v-if="paymentMethods.length">
      <li :key="paymentMethod.id" v-for="paymentMethod in paymentMethods">

          <div class="ccard-detail flex items-center">
            <div class="ccard-detail__icon">
            <i class="fa fa-credit-card fa-fw"></i>
            </div>
            <div class="ccard-detail__info">
              <div class="ccard-detail__number">
                <span class="ccard-detail__placeholder">XXXX XXXX XXXX</span> {{paymentMethod.last_four?paymentMethod.last_four:'XXXX'}}
              </div>
              <div class="ccard-detail__expiry">
                {{paymentMethod.exp_month}}/{{paymentMethod.exp_year}}
              </div>
              <div v-if="paymentMethod.is_default">Current Default</div>
            </div>
            <div class="ccard-detail__actions">
              <ladda-button v-if="!paymentMethod.is_default" class="btn btn-info" :click="() => { setDefaultPayment(paymentMethod.id) }">
                <i class="fa fa-star"></i>
              </ladda-button>
              <ladda-button class="btn btn-danger" :click="() => { removePaymentMethod(paymentMethod.id) }">
                <i class="fa fa-trash"></i>
              </ladda-button>
            </div>
          </div>
      </li>
    </ul>

    <div class="ccard-none">
      <div class="ccard-none__container">
        <div class="ccard-none__label" v-if="!paymentMethods.length">
          You don't have any card details stored.
        </div>
        <div class="ccard-none__actions">
          <router-link :to="{ name: `${ $route.name }.card-details`, params: { id: user.id } }" active-class="" class="btn btn-sm btn-primary">
            <i class="fa fa-fw fa-plus"></i>
            Add a card
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { helpers } from 'mixins/users'
import { notify } from 'utils'
import LaddaButton from 'codium-ladda-button'

export default {
  mixins: [helpers],

  components: {
    LaddaButton
  },

  data () {
    return {
      paymentMethods: []
    }
  },
  mounted () {
    this.loadPaymentMethods()
  },
  computed: mapState('user', ['user']),
  methods: {
    loadPaymentMethods () {
      return this.$http.get('card/payment-methods')
        .then(response => {
          this.paymentMethods = response.data
        })
    },
    removePaymentMethod (paymentID) {
      return this.$http.post('card/remove-payment', {
        id: paymentID
      }).then(() => {
        this.loadPaymentMethods().then(() => {
          notify.success('Successfully deleted card.')
        })
      })
    },
    setDefaultPayment (paymentID) {
      return this.$http.post('card/set-default-payment', {
        id: paymentID
      }).then(() => {
        this.loadPaymentMethods().then(() => {
          notify.success('Default card set.')
        })
      })
    }
  }
}
</script>
